import { render, staticRenderFns } from "./score-tips.vue?vue&type=template&id=79c4f4a2&"
import script from "./score-tips.vue?vue&type=script&lang=js&"
export * from "./score-tips.vue?vue&type=script&lang=js&"
import style0 from "./score-tips.vue?vue&type=style&index=0&id=79c4f4a2&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports